import "./BestSellingPackages.module.css";
import Header from "@/reusable_sections/Header";
import TravelHero from "./sections/TravelHero";
import FeaturedTravelSpecials from "./sections/FeaturedTravelSpecials";
import ProductListingGrid from "./sections/ProductListingGrid";
import Footer from "@/reusable_sections/Footer";
export default function BestSellingPackagesPage() {
  return <div>
      <Header />
      <TravelHero />
      <FeaturedTravelSpecials />
      <ProductListingGrid />
      <Footer />
    </div>;
}